module.exports = __webpack_public_path__ + "img/nq_icon3.8277782b.png";